<nav class="buy-guide-steps__nav" aria-label="Home buying steps">
  @for (step of steps; track step.id) {
    <button
      type="button"
      class="buy-guide-steps__tab"
      [class.buy-guide-steps__tab--active]="activeStep() === step.id"
      [attr.aria-current]="activeStep() === step.id ? 'step' : null"
      (click)="selectStep(step.id)">
      <span class="buy-guide-steps__tab-num">{{ step.id }}</span>
      <span class="buy-guide-steps__tab-label">{{ step.shortTitle }}</span>
    </button>
  }
</nav>

<div class="buy-guide-steps__progress" role="presentation">
  <div
    class="buy-guide-steps__progress-fill"
    [style.width.%]="(activeStep() / steps.length) * 100"></div>
</div>

@for (step of steps; track step.id) {
  @if (activeStep() === step.id) {
    <article class="buy-guide-steps__panel">
      <div class="buy-guide-steps__media">
        <img
          [ngSrc]="step.image"
          width="960"
          height="540"
          [alt]="step.alt"
          class="buy-guide-steps__image">
        <span class="buy-guide-steps__badge">Step {{ step.id }} of {{ steps.length }}</span>
      </div>
      <div class="buy-guide-steps__copy">
        <h3 class="buy-guide-steps__title">{{ step.title }}</h3>
        <p class="buy-guide-steps__description">{{ step.description }}</p>
      </div>
    </article>
  }
}
